<template>
  <div class="main-div" style="">
    <nav
      ref="navbar"
      class="navbar navbar-expand-lg navbar-light bg-black"
      :class="{ 'sticky-navbar': isSticky, 'navbar-animated': isSticky !== null }"
    >
      <div class="container">
        <router-link class="navbar-brand" to="/">
<!--          <img src="@/assets/logo_name.png" width="150" alt="Logo"/>-->
          <img width="200" src="@/assets/heedLogoWhite.png" alt="">
<!--          <h2 class="fw-bold mb-0">heed</h2>-->
        </router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <i class="fa fa-navicon" style="    font-size: 30px;"></i>
        </button>
        <div id="navbarSupportedContent" class="collapse navbar-collapse">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0 text-white-50">
            <li class="nav-item">
              <router-link to="/about-us" class="btn me-2">
                {{ $t("About us") }}
              </router-link>
            </li>
            <li class="nav-item pe-2">
              <a href="/#contact-form" class="btn me-2">
                {{ $t("Contact us") }}
              </a>
            </li>
<!--            <li class="nav-item pe-2">-->
<!--              <router-link to="/register" class="btn me-2">-->
<!--                {{ $t("Register") }}-->
<!--              </router-link>-->
<!--            </li>-->
            <li class="nav-item pe-2">
              <router-link to="/register" class="btn me-2">
                {{ $t("Register") }}
              </router-link>
            </li>
            <li class="pe-2">
              <router-link v-if="hasPortalAccess" :to="portalLink" class="btn btn-default text-white me-2 fw-bold mb-2 mt-1">
                {{ $t("Portal") }}
              </router-link>
            </li>
            <li class="pe-2">
              <router-link v-if="!$store.state.user.loggedIn" to="/login" class="btn btn-default text-white fw-bold mt-1">
                {{ $t("Sign in") }}
              </router-link>
              <base-button v-else class="btn btn-default text-white mt-1" @click="$store.dispatch('signOut')">
                {{ $t("Log out") }}
              </base-button>
            </li>
            <li class="pe-2">
              <div class="btn-group language-changer">
                <button type="button" class="btn btn-primary dropdown-toggle text-white mt-1" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa fa-globe"></i> {{ locale.label }}
                </button>
                <ul class="dropdown-menu">
                  <li class="text-center">
                    <button class="dropdown-item text-muted p-2" :class="{'active' : locale.value === 'en'}" type="button" @click="setLocale('en')">
                      <img width="25" src="@/assets/images/flags/GB.png"> En
                    </button>
                  </li>
                  <li><hr class="dropdown-divider" style="margin: 0px;"></li>
                  <li class="text-center">
                    <button :class="{'active' : locale.value === 'el'}" class="dropdown-item p-2" type="button" @click="setLocale('el')">
                      <img width="25" src="@/assets/images/flags/GR.png"> Ελ
                    </button>
                  </li>
</ul>
              </div>
<!--              <multiselect-->
<!--                  v-model="locale"-->
<!--                  class="custom-transition-form"-->
<!--                  label="label"-->
<!--                  :show-labels="false"-->
<!--                  track-by="value"-->
<!--                  placeholder="Language"-->
<!--                  :options="locales"-->
<!--                  :searchable="false"-->
<!--              >-->
<!--              </multiselect>-->
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- Navbar -->
    <div>
      <router-view v-slot="{ Component }">
          <component :is="Component" :key="$route.fullPath"></component>
      </router-view>
    </div>
    <div v-if="showCookieMessage" class="cookie-message">
      <div class="row">
      <div class="col-md-10">
      {{ $t("We use cookies to enhance your browsing experience, personalize content, and analyze our traffic.") }}
      {{ $t("By continuing to use our site, you agree to our use of cookies. To learn more, read our") }} <a target="_blank" class="text-decoration-underline text-primary" href="/cookies-policy.html">{{ $t("Cookie Policy") }}</a>.
      </div>
      <div class="col-md-2 " style="min-width: 150px">
      <button class="btn btn-primary mt-2" @click="acceptCookies()">{{ $t("Got it!") }}</button>
      </div>
      </div>
    </div>
    <footer class="py-5 bg-black">
      <div class="container">
        <div class="row align-items-start  justify-content-xl-between">
<!--          <div class="col-md-3 text-white"></div>-->
<!--          <div class="col-md-3 text-white"></div>-->
          <div class="col-md-6 text-white text-md-start">
            <h3 class="text-white">{{ $t("Information") }}</h3>
            <a class="link-light text-white-50  text-decoration-none fw-bold" href="/#contact-form">{{ $t("Contact us") }}</a><br>
            <a class="link-light text-white-50  text-decoration-none fw-bold" :href="`/terms-and-conditions${$store.state.locale === 'el' ? '-gr' : ''}.html`">{{ $t("Terms and Conditions") }}</a><br>
            <a class="link-light text-white-50  text-decoration-none fw-bold" :href="`/privacy-policy${$store.state.locale === 'el' ? '-gr' : ''}.html`">{{ $t("Privacy Policy") }}</a><br>
            <a class="link-light text-white-50  text-decoration-none fw-bold" :href="`/cookies-policy${$store.state.locale === 'el' ? '-gr' : ''}.html`">{{ $t("Cookie Policy") }}</a><br>
           </div>
          <div class="col-md-6 text-white text-md-end pt-xs-5">
            <h3 class="text-white">{{ $t("Contact Details") }}</h3>
            <div>
              <div class="text-white-50 fw-bold"><a class="text-white-50 text-decoration-underline" href="tel:+35724022136"> +357 24 022136</a></div>
              <div class="text-white-50 fw-bold"> <a class="text-white-50 text-decoration-underline" href="mailto:info@heed.com.cy">info@heed.com.cy</a></div>
              <div class="float-end pt-3">
              <a href="https://www.facebook.com/profile.php?id=61574086859142" class="social-icon si-small me-1 h-op-09 text-white bg-facebook">

                <i class="fa-brands fa-facebook-f"></i>

                <i class="fa-brands fa-facebook-f"></i>

              </a>
              <a href="https://www.instagram.com/heed.cy?igsh=MWowaHpwcTA4bDd3aw==" class="social-icon si-small me-1 h-op-09 text-white bg-instagram">

                <i class="fa-brands fa-instagram"></i>

                <i class="fa-brands fa-instagram"></i>

              </a>
              </div>
            </div>
</div>

          <div class="col-xl-12 text-white text-md-start pt-3">
            <div class=" copyright text-md-right text-xl-left fw-bolder float-md-start">
              &copy; {{ year }} MGY HEED LTD
</div>
            <div class="fw-bold float-end text-end">
              <div class="col-xl-12 text-md-end pt-3">
                <img src="@/assets/images/ssl-small.png" width="100" class=" " alt="..."> <br>
              </div>
            </div>
</div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import packageData from "../../package.json"
import BaseButton from "@/components/BaseButton"

export default {
  name: "top-layout",
  components: {
    BaseButton,
    // VueMultiselect
  },
  data() {
    return {
      locale: "",
      version: null,
      locales: [
        {label: "EN", value: "en"},
        {label: "Ελ", value: "el"},
        // {label: 'Russian', value: 'ru'}
      ],
      year: new Date().getFullYear(),
      showMenu: false,
      isSticky: null, // null initially so animation doesn't run on mount
    }
  },
  computed: {
    showCookieMessage() {
      return !this.$store.state.acceptedCookies
    },
    portalLink(){
      let role = this.$store.state.user.claims.role ?? null
      if (role === null){
        return ""
      }
      switch (role){
        case "system":
          return "/dashboard"
        case "employee":
          return "/find-a-shift"
        case "client":
          return "/requests"
      }

      return ""
    },
    hasPortalAccess(){
      return this.$store.state.user.claims !== null && this.$store.state.user.claims.hasOwnProperty("role")
    }
  },
  watch: {
    locale(newVal) {
      console.log("locale changed", newVal)
    },
  },
  mounted() {
    this.version = packageData.version
    this.setLocaleLabel()

    // Sticky navbar scroll logic
    this.handleScroll = () => {
      // Scroll Y threshold for sticky, can tune if needed
      this.isSticky = window.scrollY > 50
    }
    window.addEventListener("scroll", this.handleScroll)
    // Initialize in case already scrolled on mount
    this.$nextTick(() => this.handleScroll())
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    acceptCookies() {
      this.$store.dispatch("acceptCookies")
    },
    setLocaleLabel(){
      let localeSelected = this.locales.find( l => l.value === this.$store.state.locale)

      if(localeSelected){
        this.locale = localeSelected
      }
    },
    setLocale (locale) {
      // this.$store.state.locale = value
      // console.log(locale.toLowerCase())
      this.$i18n.locale = locale.toLowerCase()
      this.$store.dispatch("setLocale", locale.toLowerCase())
      // without this line it didn't work
      this.$moment.locale(locale.toLowerCase())
      this.setLocaleLabel()
    },
  },
}
</script>
<style lang="scss">
.locale-changer select {
  /*background: transparent;*/
  border: none;
  /*color: white;*/
}
.locale-changer{
  margin-left: auto !important;
  cursor: pointer;
  padding-top: 10px;}

.locale-changer select:focus-visible {
  outline: none;
}
.multiselect.small-select .multiselect__select {
  padding: 4px 6px;
  height: 30px;
  width: 30px;
}

.multiselect.small-select .multiselect__tags {
  max-height: 30px;
  padding: 5px 27px 0 4px;
  min-height: 30px;
  background: unset;
}


@media(min-width: 767px)  {
  .mb-only{
    display: none !important;
  }
}

ul.dropdown-menu.show {
  padding: 0;
}
a.active.router-link-exact-active.nav-link.dropdown-item {
  color: white !important;
}
ul.dropdown-menu.show {
  border-radius: 0px 0 5px 5px;
}

.navbar .nav-item a {
  color: rgba(255, 255, 255, 0.8) !important;
  font-weight: 500;
  font-size: larger;
  padding: 8px;
}

.navbar .nav-item a.active.router-link-exact-active.nav-link, .navbar .nav-item a:hover {
  background-image: linear-gradient(90deg,#ffffff, #ffffff 50%,#ffffff 0);
  background-size: 200% 100%;
  background-position: -100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  transition: all .3s ease-in-out;
  text-shadow: 0 0 1px #ffffff;
}

.cookie-message {
  position: fixed;
  bottom: 0;
  left: 0;
  width: calc(100% - 40px);
  padding: 20px;
  background-color: #333;
  color: #fff;
  text-align: left;
  z-index: 10;
  font-size: 17px;
  font-weight: 500;
  margin: 20px;
  box-shadow: 0 4px 4px #00000082;
  border-radius: 6px;
}

/* Sticky navbar animation */
.sticky-navbar {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1050;
  box-shadow: 0 2px 6px 0 #2225;
  animation: navbarSlideDown 0.35s cubic-bezier(.44,2,.49,.99);
  background-color: #111 !important;
  transition: background 0.3s, box-shadow 0.2s;
}
.sticky-navbar .container {
  background: none !important;
}
.navbar-animated {
  transition: top 0.35s cubic-bezier(.44,2,.49,.99), box-shadow 0.2s, background 0.3s;
}
@keyframes navbarSlideDown {
  0% {
    transform: translateY(-20%);
    opacity: 0.9;
  }
  80% {
    opacity: 1;
    transform: translateY(1%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>